const SecureSimpliLeftSideSection = () => {
  return (
    <div className="order-2 md:order-1 my-4 md:mt-0 md:p-10 md:w-1/2">
      <div className="flex flex-col justify-center items-center text-[#16283D]">
        <div className="flex justify-center items-center w-[50px] h-[50px] md:w-[150px] md:h-[150px] p-2 md:p-3 gap-[60px] aspect-square rounded-[12px] md:rounded-[36px] bg-[#E9E5FA] mb-4">
          <img
            src={process.env.PUBLIC_URL + "/static/images/darkblue-vault.svg"}
            alt="Simpli"
            className="max-w-full max-h-full"
          />
        </div>

        <h2 className="text-3xl font-bold mb-3 text-center">
          <span>Congratulations,</span>
          <span className="block">you’re on the first step</span>
        </h2>

        <p className="text-lg text-center opacity-90  mb-4">Your secure digital vault in 3 simple steps</p>
        {/* 3-Step List */}
        <div className="border rounded-xl bg-white text-[#16283D] w-full shadow-sm p-2 space-y-4">
          <div className="border rounded-xl p-4">
            <div className="flex space-x-3 items-center">
              <div className="flex flex-col justify-center items-center w-[35px] h-[35px] p-[2.8px] gap-[14.735px] aspect-square rounded-[8.4px] bg-[#E9E5FA]">
                <img
                  src={process.env.PUBLIC_URL + "/static/images/user-icon.svg"}
                  alt="User Icon"
                  className="text-blue-600"
                />
              </div>

              <div>
                <p className="font-bold text-sm md:text-lg">Step 1: Create and secure your account</p>
              </div>
            </div>
            <div className="mt-2">
              <p className="text-xs md:text-base text-[#16283D]">
                Set up your account and verify your identity to keep your data safe
              </p>
            </div>
          </div>
          <div className="border rounded-xl p-4">
            <div className="flex space-x-3 items-center">
              <div className="flex flex-col justify-center items-center w-[35px] h-[35px] p-[2.8px] gap-[14.735px] aspect-square rounded-[8.4px] bg-[#E9E5FA]">
                <img
                  src={process.env.PUBLIC_URL + "/static/images/upload-icon.svg"}
                  alt="User Icon"
                  className="text-blue-600 text-xl"
                />
              </div>
              <div>
                <p className="font-bold text-sm md:text-lg">Step 2: Upload your essential documents</p>
              </div>
            </div>
            <div className="mt-2">
              <p className="text-xs md:text-base text-[#16283D]">
                Add your IDs, legal papers, receipts, photos, and more
              </p>
            </div>
          </div>
          <div className="border rounded-xl p-4">
            <div className="flex space-x-3 items-center">
              <div className="flex flex-col justify-center items-center w-[35px] h-[35px] p-[2.8px] gap-[14.735px] aspect-square rounded-[8.4px] bg-[#E9E5FA]">
                <img
                  src={process.env.PUBLIC_URL + "/static/images/access-anytime.svg"}
                  alt="User Icon"
                  className="text-blue-600 text-xl"
                />
              </div>
              <div>
                <p className="font-bold text-sm md:text-lg">Step 3: Access anytime, anywhere</p>
              </div>
            </div>
            <div className="mt-2">
              <p className="text-xs md:text-base text-[#16283D]">
                Your files are always within reach, no matter where you are
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SecureSimpliLeftSideSection;
